import { render, staticRenderFns } from "./ClientesTablaActions.vue?vue&type=template&id=241f13db&scoped=true"
import script from "./ClientesTablaActions.vue?vue&type=script&lang=js"
export * from "./ClientesTablaActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f13db",
  null
  
)

export default component.exports